import { App } from 'vue';
import tooltipDirective from './Tooltip/';

// register all directives
function directives(app: App<Element>) {
  tooltipDirective(app);
}

export default directives;
